<template>
  <navbar navbar-menu-classes="navbar-right"
          :show-navbar.sync="showNavbar">
    <template slot="navbar-menu">
      <router-link to="/login" class="nav-item" tag="li">
        <a class="nav-link font-weight-bold">
          <i class="nc-icon nc-tap-01"></i> {{$t('login.title')}}
        </a>
      </router-link>
      <router-link to="/forgot_password" class="nav-item" tag="li">
        <a class="nav-link font-weight-bold">
          <i class="nc-icon nc-lock-circle-open"></i> {{$t('login.forgotPassword')}}
        </a>
      </router-link>
    </template>
  </navbar>
</template>

<script>
  import {Navbar} from 'src/components'
  import { mapState } from 'vuex';
  export default {
    name: 'main-navbar',
    components: {
      Navbar
    },
    computed: {
      ...mapState({
        clientLogo: state => state.config.settings.logo || 'https://acceptatie.carriere.nu/wp-content/themes/carriere-nu/dist/images/logo-white_7307f938.svg'
      })
    },
    data() {
      return {
        showNavbar: false
      }
    }
  }
</script>

<style scoped>

</style>
